import { useEffect, useRef, useState } from "react";
import { LETRAS_STOP } from "../../domain/stop.js";

export function StopLetterDraw({ letraFinal, duracaoMs = 4000, aoTerminar }) {
  const [letter, setLetter] = useState("?");
  const [finished, setFinished] = useState(false);
  const timeout = useRef(null);
  const onFinish = useRef(aoTerminar);
  onFinish.current = aoTerminar;

  useEffect(() => {
    if (!letraFinal) return undefined;
    setFinished(false);
    const drawDuration = Math.max(duracaoMs - 700, 200);
    let active = true;
    const tick = (elapsed, delay) => {
      if (!active) return;
      if (elapsed >= drawDuration) {
        setLetter(letraFinal);
        setFinished(true);
        timeout.current = setTimeout(
          () => active && onFinish.current?.(),
          duracaoMs - drawDuration,
        );
        return;
      }
      setLetter(LETRAS_STOP[Math.floor(Math.random() * LETRAS_STOP.length)]);
      const nextDelay = Math.min(delay * 1.18, 260);
      timeout.current = setTimeout(
        () => tick(elapsed + delay, nextDelay),
        delay,
      );
    };
    tick(0, 60);
    return () => {
      active = false;
      clearTimeout(timeout.current);
    };
  }, [letraFinal, duracaoMs]);

  return (
    <div className="stop-letter-draw">
      <p>{finished ? "A letra da rodada é..." : "Sorteando a letra..."}</p>
      <div className={finished ? "finished" : ""}>{letter}</div>
    </div>
  );
}
